import { createAction, props } from '@ngrx/store';

export const getDrivers = createAction('[Drivers] Get');
export const storeDrivers = createAction('[Drivers] Store', props<{ list: any }>());
